const employees = [
  {
    id: 1,
    empId: 'NC04210001',
    firstName: 'Ganesh',
    lastName: 'R',
    designation: {
      id: 10,
      code: 'AM',
      name: 'Ass. Manager',
    },
    location: {
      id: 20,
      name: 'Nagercoil',
    },
    region: {
      id: 30,
      name: 'Nagercoil',
    },
    dateOfJoining: '2018-01-01',
    dateOfRelieving: '',
    pan: 'APKL1245856',
    aadhar: '1254895623564587',
    idCard: {
      id: 40,
      cardNumber: 'LDK124578',
      cardExpDate: '2021-12-12',
      isActive: true,
    },
    bankInfo: {
      id: 50,
      bankName: 'HDFC Bank',
      accountNumber: '2356895623457845',
      branch: 'Nagercoil',
      ifsc: 'HDFC000254',
    },
    contact: {
      phone1: '9875632145',
      phone2: '8856987456',
      email: 'ganeshr@gmail.com',
      address1: '14, Amman kovil street',
      address2: 'Krishnan Kovil',
      city: 'Nagercoil',
      state: 'TN',
      pinCode: '629001',
    },
    documents: [
      {
        id: 60,
        type: 'PAN',
        docNumber: 'APD6565132',
        file: 'Pan_Doc.pdf',
      },
      {
        id: 61,
        type: 'Driving Licence',
        docNumber: 'TN20245623DL',
        file: 'driving.jpg',
      },
    ],
  },
  {
    id: 2,
    empId: 'NC04210002',
    firstName: 'Ramakrishnan',
    lastName: 'N',
    designation: {
      id: 11,
      code: 'TL',
      name: 'Team Lead',
    },
    location: {
      id: 20,
      name: 'Karur',
    },
    region: {
      id: 30,
      name: 'Madurai',
    },
    dateOfJoining: '2019-04-10',
    dateOfRelieving: '',
    pan: 'DIL1245856',
    aadhar: '4587569812542563',
    idCard: {
      id: 42,
      cardNumber: 'LDK895623',
      cardExpDate: '2021-12-22',
      isActive: true,
    },
    bankInfo: {
      id: 51,
      bankName: 'ICIC Bank',
      accountNumber: '012423567845122356',
      branch: 'Nagercoil',
      ifsc: 'ICICI1245562',
    },
    contact: {
      phone1: '7896587458',
      phone2: '9565874589',
      email: 'ramki@gmail.com',
      address1: '75, Krishna kovil main road',
      address2: 'Krishnan Kovil',
      city: 'Nagercoil',
      state: 'TN',
      pinCode: '629001',
    },
    documents: [
      {
        id: 63,
        type: 'PAN',
        docNumber: 'QRD12457845',
        file: 'pan.pdf',
      },
      {
        id: 64,
        type: 'Driving Licence',
        docNumber: 'TN202004122656',
        file: 'driving.pdf',
      },
    ],
  },
  {
    id: 3,
    empId: 'MD04210035',
    firstName: 'Alex',
    lastName: 'Paul',
    designation: {
      id: 11,
      code: 'TL',
      name: 'Field Engineer',
    },
    location: {
      id: 20,
      name: 'Dindigul',
    },
    region: {
      id: 30,
      name: 'Madurai',
    },
    dateOfJoining: '2019-10-08',
    dateOfRelieving: '',
    pan: 'RL12458563',
    aadhar: '8956457823564856',
    idCard: {
      id: 42,
      cardNumber: 'LDK895623',
      cardExpDate: '2021-12-22',
      isActive: true,
    },
    bankInfo: {
      id: 51,
      bankName: 'ICIC Bank',
      accountNumber: '012423567845122356',
      branch: 'Nagercoil',
      ifsc: 'ICICI1245562',
    },
    contact: {
      phone1: '7896587458',
      phone2: '9565874589',
      email: 'ramki@gmail.com',
      address1: '75, Krishna kovil main road',
      address2: 'Krishnan Kovil',
      city: 'Nagercoil',
      state: 'TN',
      pinCode: '629001',
    },
    documents: [
      {
        id: 63,
        type: 'PAN',
        docNumber: 'QRD12457845',
        file: 'pan.pdf',
      },
      {
        id: 64,
        type: 'Driving Licence',
        docNumber: 'TN202004122656',
        file: 'driving.pdf',
      },
    ],
  },
];

export { employees };
